export class DynamicDate {
  direction: 'ago' | 'from-now';
  num?: number;
  unit?: 'days';

  static STRING_REGEX = /^DYNAMIC_DATE\[(\d{1,3}_days_(ago|from-now))\]$/;

  constructor(num?: number, unit?, direction?) {
    this.num = num;
    this.unit = unit;
    this.direction = direction;
  }

  static parse(value: string): DynamicDate {
    if (!DynamicDate.STRING_REGEX.test(value)) {
      return null;
    }
    const stringValue = value.match(DynamicDate.STRING_REGEX)[1];
    const [num, unit, pastOrFuture] = stringValue.split('_');
    return new DynamicDate(parseInt(num), unit, pastOrFuture);
  }

  toString(): string {
    return `DYNAMIC_DATE[${this.num}_${this.unit}_${this.direction}]`;
  }
}
